import React, { useEffect, useState } from "react";
import { useLang } from "@/contexts/LanguageContext";
import { ChevronLeft, ChevronRight } from "lucide-react";

const GALLERY = [
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/1mxkd6ky_IMG-20260820-WA0012.jpg",
    caption_en: "\"Oh Baby, It's a Boy\": full-team baby shower celebration",
    caption_fr: "« Oh Baby, It's a Boy » : célébration de baby shower en équipe",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/n354apv3_IMG-20260820-WA0017.jpg",
    caption_en: "Honouring our expecting colleague at the baby shower",
    caption_fr: "À l'honneur de notre collègue à la baby shower",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/b7b5n5pg_web1.jpg",
    caption_en: "Proudly wearing our CUPE Local 4957 colours",
    caption_fr: "Fièrement aux couleurs du SCFP Local 4957",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/b9vi5bvq_web2.jpg",
    caption_en: "Proud Member of CUPE: on shift at the front desk",
    caption_fr: "Fier membre du SCFP : en quart à l'accueil",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/pg1z1t20_web3.jpg",
    caption_en: "Proud Member of CUPE: strong and standing tall",
    caption_fr: "Fière membre du SCFP : forte et debout",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/wxroxwvz_IMG-20260820-WA0012.jpg",
    caption_en: "Happy Birthday celebration with the team",
    caption_fr: "Célébration d'anniversaire avec l'équipe",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/jcst3sp0_IMG-20260820-WA0011.jpg",
    caption_en: "Sharing food and laughs at the office",
    caption_fr: "Partage de repas et de rires au bureau",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/bweje24w_IMG-20260820-WA0015.jpg",
    caption_en: "Birthday cheers from the crew",
    caption_fr: "Souhaits d'anniversaire de l'équipe",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/f7v0qwl5_IMG-20260820-WA0014.jpg",
    caption_en: "Potluck spread: members feeding members",
    caption_fr: "Repas-partage: les membres nourrissent les membres",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_cupe-oakpark/artifacts/mquyoirr_IMG-20260820-WA0016.jpg",
    caption_en: "Baby shower celebration on the floor",
    caption_fr: "Célébration de baby shower sur le plancher",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/u9aktxdc_IMG-20260612-WA0086.jpg",
    caption_en: "The Oakpark front desk and care team",
    caption_fr: "Équipe d'accueil et de soins d'Oakpark",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/728xiazv_Screenshot_20260613_215035_WhatsAppBusiness.jpg",
    caption_en: "Plating with pride: our food services team",
    caption_fr: "Dressage des assiettes : notre équipe des services alimentaires",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/k78v1304_Screenshot_20260613_215054_WhatsAppBusiness.jpg",
    caption_en: "Serving with a smile",
    caption_fr: "Servir avec le sourire",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/trov6cr8_Screenshot_20260612_183345_ChatGPT.jpg",
    caption_en: "Frontline care team at Oakpark",
    caption_fr: "Équipe de soins de première ligne à Oakpark",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/ehtug3d4_Screenshot_20260612_183350_ChatGPT.jpg",
    caption_en: "Celebrating a member milestone",
    caption_fr: "Célébration d'un jalon de membre",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/qwkroq0z_Screenshot_20260612_191925_WhatsAppBusiness.jpg",
    caption_en: "Team gathering: It's a girl celebration",
    caption_fr: "Rassemblement d'équipe : célébration",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/qz8dfqti_Screenshot_20260612_192055_WhatsAppBusiness.jpg",
    caption_en: "Honouring a colleague at the baby shower",
    caption_fr: "À l'honneur d'une collègue lors de la baby shower",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/fknhobyp_Screenshot_20260612_191918_WhatsAppBusiness.jpg",
    caption_en: "Members together for a colleague's celebration",
    caption_fr: "Membres ensemble pour la célébration d'une collègue",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/szn872i4_Screenshot_20260612_192657_WhatsAppBusiness%281%29.jpg",
    caption_en: "PSW on shift: pride in our scrubs",
    caption_fr: "PSSP en quart : fierté dans nos uniformes",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/cw158ot9_Screenshot_20260612_192723_WhatsAppBusiness.jpg",
    caption_en: "Side by side on the floor",
    caption_fr: "Côte à côte sur le plancher",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cupe-oakpark/artifacts/63i7ta6q_2a58f57a4609d7d45028fdfd8a27aa4aa82510e078986c58d2408826569eb3b6.png",
    caption_en: "Baby shower celebration with our food services team",
    caption_fr: "Célébration de baby shower avec l'équipe des services alimentaires",
  },
];

export default function Gallery() {
  const { t, lang } = useLang();
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % GALLERY.length), 6000);
    return () => clearInterval(id);
  }, []);

  const prev = () => setIdx((i) => (i - 1 + GALLERY.length) % GALLERY.length);
  const next = () => setIdx((i) => (i + 1) % GALLERY.length);

  return (
    <div data-testid="gallery-page">
      <section className="bg-gradient-to-br from-pink-50 via-white to-rose-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900">{t("gallery.title")}</h1>
          <p className="text-lg text-slate-600 mt-3 max-w-2xl">{t("gallery.sub")}</p>
          <div className="h-1 w-20 cupe-gradient rounded-full mt-4" />
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="relative bg-slate-900 rounded-2xl overflow-hidden shadow-xl" data-testid="gallery-slideshow">
          <div className="relative aspect-[16/9] bg-slate-900">
            {GALLERY.map((item, i) => (
              <img
                key={i}
                src={item.src}
                alt={lang === "fr" ? item.caption_fr : item.caption_en}
                className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0"}`}
                data-testid={`gallery-slide-${i}`}
              />
            ))}

            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-900/85 via-slate-900/40 to-transparent pt-16 pb-6 px-6 md:px-10">
              <p className="text-white text-base md:text-lg font-semibold" data-testid="gallery-caption">
                {lang === "fr" ? GALLERY[idx].caption_fr : GALLERY[idx].caption_en}
              </p>
              <p className="text-white/70 text-sm mt-1">{idx + 1} / {GALLERY.length}</p>
            </div>

            <button
              onClick={prev}
              aria-label="Previous"
              className="absolute left-3 md:left-5 top-1/2 -translate-y-1/2 bg-white/85 hover:bg-white text-slate-900 rounded-full p-2 md:p-3 shadow transition"
              data-testid="gallery-prev"
            >
              <ChevronLeft size={22} />
            </button>
            <button
              onClick={next}
              aria-label="Next"
              className="absolute right-3 md:right-5 top-1/2 -translate-y-1/2 bg-white/85 hover:bg-white text-slate-900 rounded-full p-2 md:p-3 shadow transition"
              data-testid="gallery-next"
            >
              <ChevronRight size={22} />
            </button>
          </div>

          <div className="flex justify-center gap-1.5 py-3 bg-slate-900">
            {GALLERY.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Go to slide ${i + 1}`}
                className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-white" : "w-2 bg-white/40 hover:bg-white/60"}`}
                data-testid={`gallery-dot-${i}`}
              />
            ))}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2" data-testid="gallery-thumbs">
          {GALLERY.map((item, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`aspect-square overflow-hidden rounded-lg border-2 transition ${i === idx ? "border-[#d81b7a] shadow" : "border-transparent opacity-70 hover:opacity-100"}`}
              data-testid={`gallery-thumb-${i}`}
            >
              <img src={item.src} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
